/* Decriptions: This function will get all applications that have billing Number.
 Author: Honoratt Mark B Ocbina
 Version: 1.0
 History: Committed but not implemented
 Input: Where isDeleted ne 1, ownedBy a particular user, and order_payment_no is equal to 0
  */

import React, { useState, useEffect } from "react";
import { Row, Col, Card, Table, Alert, Space, Button, Input } from "antd";
import { API, graphqlOperation, Auth } from "aws-amplify";
import { SmileOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import xlsx from "json-as-xlsx";
import Swal from "sweetalert2";
import { jwtDecode } from "jwt-decode";

import { updateCreateOrderOfBilling } from "../../graphql/mutations";
import { listCreateOrderOfBillings } from "../../graphql/queries";
import fetchItemsNextToken from "../../function/fetchItemsNextTokenZau";
import ApplicationDetailModal from "./ApplicationDetail";
import "./checkop.css";

const { Search } = Input;

//TODO => token failure, Automatic loading and payment status check
const CheckPaidOp = (props) => {
  const [loadingSwalVisible, setLoadingSwalVisible] = useState(true);
  const [searchData, setSearchData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [application, setApplication] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [token, setToken] = useState("");

  const pageSize = 10;
  const [current, setCurrent] = useState(1);

  const { REACT_APP_CHECK_PAYMENT_STATUS_MULTIPLE } = process.env;

  const fetchListofPermitLocationClearance = async (id) => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            order_payment_no: { ne: "0" },
            OrNumber: { eq: "0" },
            OrDate: { eq: "0" },
          },
          limit: 1000,
        },
      };
      const a = fetchItemsNextToken(queryData);
      a.then(async (response) => {
        const arrayofbillingno = [];

        for (let i = 0; i < response.length; i++) {
          arrayofbillingno.push(response[i].order_payment_no);
        }

        if (arrayofbillingno.length > 1) {
          const toReturn = JSON.stringify(arrayofbillingno.join("|")).replace(
            /"/g,
            ""
          );

          try {
            const apiSend = {
              search_value: toReturn,
            };

            try {
              if (token) {
                const paymentStatusResponse = await fetch(
                  REACT_APP_CHECK_PAYMENT_STATUS_MULTIPLE,
                  {
                    headers: {
                      "Content-Type": "application/json",
                      authorization: token, // Replace YOUR_AUTH_TOKEN with your actual token
                    },
                    method: "POST",
                    body: JSON.stringify(apiSend),
                  }
                );
                const paymentStatusData = await paymentStatusResponse.json();

                if (paymentStatusData.data.totalRecords === 0) {
                  Swal.fire({
                    title: "No Payment Details Found",
                    text: "There are no payment details for this user.",
                    icon: "warning",
                  });
                } else if (paymentStatusData.data.totalRecords >= 1) {
                  let k = [];

                  for (
                    let i = 0;
                    i < Object.values(paymentStatusData.data.details).length;
                    i++
                  ) {
                    if (
                      Object.values(paymentStatusData.data.details)[i]
                        .PostFlag !== "C" ||
                      Object.values(paymentStatusData.data.details)[i]
                        .PostFlag !== "V"
                    ) {
                      k.push(Object.values(paymentStatusData.data.details)[i]);
                    }
                  }

                  setSearchData(k);
                  setOriginalData(k);
                }
                setLoadingSwalVisible(false);
              }
            } catch (error) {
              Swal.fire({
                title: "Error",
                icon: "error",
                text: "Failed to check payment status.",
              });
            }
          } catch (error) {
            Swal.fire({
              title: "Error",
              icon: "error",
              text: "Failed to generate token.",
            });
          }
        } else {
          Swal.fire({
            title: "No Billing Number found",
            icon: "success",
          });
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchListofPermitLocationClearance(props.ownerId);
    sessionToken();
  }, [token]);

  async function sessionToken() {
    let session = await Auth.currentSession();
    let accessToken = session.getAccessToken().getJwtToken();

    // Decode the token to get the payload
    const decodedToken = jwtDecode(accessToken);

    // Get the current time
    const currentTime = Math.floor(Date.now() / 1000) - 30;

    if (decodedToken.exp < currentTime) {
      // The token is expired

      // Refresh the session
      session = await Auth.currentSession(true); // Pass true to force refresh

      // Get the new access token
      accessToken = session.getAccessToken().getJwtToken();
    }

    setToken(accessToken);
  }

  useEffect(() => {
    if (loadingSwalVisible) {
      Swal.fire({
        title: "Loading...",
        html: '<div class="custom-loader-container"><div class="custom-loader"></div></div>',
        onBeforeOpen: () => {
          Swal.showLoading();
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      });
    } else {
      Swal.fire({
        title: "List of Paid Applications",
        icon: "success",
        onBeforeOpen: () => {
          Swal.showLoading();
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then(() => {
        Swal.close();
      });
    }
  }, [loadingSwalVisible, searchData]);

  const handleCheckOfDetails = async (billNumber) => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            order_payment_no: { contains: billNumber },
          },
          limit: 1000,
        },
      };

      const response = await fetchItemsNextToken(queryData);

      if (!response) {
        throw new Error("No data found");
      }

      const { owner, order_payment_no, application_no } = response[0];
      setApplication({ owner, order_payment_no, application_no });
      setShowModal(true);
    } catch (error) {
      console.log(error);
    }
  };

  const verify = async (record) => {
    setDisabled(true);

    try {
      const result = await Swal.fire({
        title: "Verify",
        text: "Please click on the appropriate button to verify or check the application:",
        showCancelButton: true,
        confirmButtonText: "Verify",
        cancelButtonText: "Cancel",
      });

      if (result.isConfirmed) {
        const apiSend = {
          search_value: record.BillNumber,
        };

        const paymentStatusResponse = await fetch(
          REACT_APP_CHECK_PAYMENT_STATUS_MULTIPLE,
          {
            headers: {
              "Content-Type": "application/json",
              authorization: token,
            },
            method: "POST",
            body: JSON.stringify(apiSend),
          }
        );

        const paymentStatusData = await paymentStatusResponse.json();

        for (const detail of Object.values(paymentStatusData.data.details)) {
          const queryData = {
            query: listCreateOrderOfBillings,
            variables: {
              filter: {
                isDeleted: { ne: "1" },
                order_payment_no: { contains: detail.BillNumber },
              },
              limit: 1000,
            },
          };

          const response = await fetchItemsNextToken(queryData);

          if (response) {
            const resultItem = await API.graphql(
              graphqlOperation(updateCreateOrderOfBilling, {
                input: {
                  id: response[0].id,
                  OrNumber: detail.ORNumber,
                  OrDate: detail.OrDate,
                  status: "5",
                },
              })
            );

            if (resultItem) {
              await Swal.fire(
                "Verified!",
                "The application has been verified.",
                "success"
              );
              setDisabled(false);
              setLoadingSwalVisible(true);
              fetchListofPermitLocationClearance();
            } else {
              Swal.fire(
                "Error1",
                "An error occurred during verification.",
                "error"
              );
            }
          } else {
            await Swal.fire(
              "Error2",
              "An error occurred during verification.",
              "error"
            ).then(() => {
              setDisabled(false);
              fetchListofPermitLocationClearance(props.ownerId);
            });
          }
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        fetchListofPermitLocationClearance(props.ownerId);
        setDisabled(false);
      }
    } catch (error) {
      Swal.fire("Error3", "An error occurred during verification.", "error");
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setApplication(null);
  };

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleSearch = (value) => {
    if (!value) {
      setSearchData(originalData); // Reset to all data if search is cleared
      return;
    }

    const filtered = originalData.filter(item =>
      Object.values(item).some(val =>
        String(val).toLowerCase().includes(value.toLowerCase())
      )
    );
    setSearchData(filtered);
  };

  const handleReset = () => {
   setSearchData(originalData);
  }

  
  const handleDownloadText = () => {
    // Choose which data to export: searchData (filtered) or originalData (all)
    const dataToExport = searchData;

    // Convert array of objects to plain text (tab-separated)
    if (!dataToExport.length) return;

    // Get headers
    const headers = Object.keys(dataToExport[0]).join("\t");
    // Get rows
    const rows = dataToExport.map(row =>
      Object.values(row).join("\t")
    );
    // Combine headers and rows
    const textContent = [headers, ...rows].join("\n");

    // Create a blob and trigger download
    const blob = new Blob([textContent], { type: "text/plain" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "paid_applications.txt";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const columns = [
    {
      title: "#",
      key: "index",
      width: 50,
      render: (text, record, index) => index + 1 + pageSize * (current - 1),
    },
    {
      title: "Billing Number",
      dataIndex: "BillNumber",
      width: 200,
      render: (text, record, index) => (
        <>
          <Link
            onClick={() => handleCheckOfDetails(record.BillNumber)}
            disabled={disabled}
            style={{ color: "black", cursor: "pointer" }}
            onMouseEnter={(e) => (e.target.style.color = "blue")}
            onMouseLeave={(e) => (e.target.style.color = "black")}
          >
            {record.BillNumber}
          </Link>
        </>
      ),
    },
    {
      title: "Official Receipt",
      dataIndex: "ORNumber",
      width: 200,
      render: (text, record, index) => (
        <>{record.ORNumber === "0" ? "-" : record.ORNumber}</>
      ),
    },
    {
      title: "Official Receipt Date",
      dataIndex: "OrDate",
      width: 200,
      render: (text, record, index) => (
        <>{new Date(record.OrDate).toLocaleDateString("en-US")}</>
      ),
    },
    {
      title: "Official Receipt Amount",
      dataIndex: "OrAmount",
      width: 200,
      render: (text, record, index) => {
        // Parse OrAmount as a number
        const originalNumber = parseFloat(record.OrAmount);

        // Check if originalNumber is a valid number
        if (isNaN(originalNumber)) {
          return "Invalid amount";
        }

        // Convert to 2 decimal places
        const formattedNumber = originalNumber.toFixed(2);

        // Format as currency in PHP (Philippine Peso)
        const formattedCurrency = Number(formattedNumber).toLocaleString(
          "en-PH",
          { style: "currency", currency: "PHP" }
        );

        // Render the formatted currency
        return formattedCurrency;
      },
    },

    {
      title: "",
      dataIndex: "-",
      width: 80,
      render: (text, record, index) => (
        <>
          <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
            <button
              className="btn btn-warning"
              onClick={() => verify(record)}
              disabled={disabled}
            >
              Verify
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => handleCheckOfDetails(record.BillNumber)}
              disabled={disabled}
            >
              View
            </button>
          </div>
        </>
      ),
    },
  ];
  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card
            hoverable
            style={{
              width: "100%",
              borderRadius: "16px",
              boxShadow: "0 0 16px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Space direction="vertical" style={{ width: "100%" }}>
              <h2>List of Paid Applications</h2>
              <hr />
            </Space>
            <Space direction="vertical" style={{ width: "100%" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>
                  <Search
                    placeholder="Search"
                    style={{ width: 400 }}
                    onSearch={handleSearch}
                    size="large"
                    allowClear
                  />
                  <Button onClick={handleReset} size="large" color="cyan" variant="solid" style={{ marginLeft: 8 }}>
                    Reset
                  </Button>
                </div>
                <Button onClick={handleDownloadText} size="large" type="primary">
                  Download as Text
                </Button>
              </div>
            </Space>
            <Space direction="vertical" style={{ width: "100%" }}>
              <Table
                dataSource={searchData}
                columns={columns}
                pagination={{
                  pageSize: pageSize,
                  current: current,
                  onChange: (page) => setCurrent(page),
                }}
              />
            </Space>
          </Card>
        </Col>
      </Row>
      {application && (
        <ApplicationDetailModal
          application={application}
          handleCloseModal={handleCloseModal}
          handleShowModal={handleShowModal}
          showModal={showModal}
        />
      )}
    </div>
  );
};

export default CheckPaidOp;
